<script lang="ts" module>
  import { onDestroy } from 'svelte';

  import type { SpellingGroup } from '@/teoCore/text/SpellCheckHandler';
  import type { TeoText } from '@/teoCore/text/TeoText';
  import TpiDrawer from '@/ui/elements/tpi-drawer/TPIDrawer.svelte';
  import { useTeoTextUiStateObserver } from '@/utils/use-teo-event-observer.svelte';

  import { createPillGroups, type SpellCheckPillGroup } from './SpellCheckComponent';

  export interface SpellCheckComponentProps {
    teoText: TeoText;
  }
</script>

<script lang="ts">
  let { teoText }: SpellCheckComponentProps = $props();
  const dimensionDrawerOpen = useTeoTextUiStateObserver(teoText.ui, 'dimensionDrawerOpen');
  const category = useTeoTextUiStateObserver(teoText.ui, 'spellCheckCategory'); // TODO: Update
  const group = useTeoTextUiStateObserver(teoText.ui, 'spellCheckGroup'); // TODO: Update

  let destroyCheckListener = teoText.spellCheck.events.addEventListener(
    'spellCheckReceived',
    onScan,
  );
  onDestroy(() => {
    destroyCheckListener();
  });

  let pillgroups: SpellCheckPillGroup[] = $state([]);

  onScan();

  function onScan() {
    pillgroups = createPillGroups(teoText.spellCheck);
  }

  function onDimensionChange(dm: string | undefined) {
    teoText.ui.update('spellCheckCategory', dm);
  }

  function onTextPropertyChange(tp: string | undefined) {
    teoText.ui.update('spellCheckGroup', tp as SpellingGroup | undefined);
  }
</script>

<TpiDrawer
  open={dimensionDrawerOpen.current}
  pillGroups={pillgroups}
  useableSubdims={['subdim4', 'subdim5']}
  dimension={category.current}
  textProperty={group.current}
  helpTopicName="language-tool"
  {onDimensionChange}
  {onTextPropertyChange}
></TpiDrawer>
